/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2023, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { ratingsAndReviews } from './reducers/index'

export const ratingsAndReviewsReducer = filterActions(ratingsAndReviews, Object.values(constants))
